import { EffectCallback, useEffect, useLayoutEffect, useRef } from "react";

/**
 * Runs an onMount effect callback when the component mounts/unmounts
 * - the callback is called each time the component mounts (twice in strict mode)
 * - the return value of the callback (if provided) is called each time the component unmounts
 * - the callback does not re-run while its component remains mounted
 * - if options.beforePaint is true, runs the onMount callback in a useLayoutEffect (before the browser repaints)
 */
export function useOnMount(onMount: EffectCallback) {
  const onMountRef = useRef(onMount);
  useEffect(() => onMountRef.current(), []);
}

/**
 * Runs an onMount effect callback when the component mounts/unmounts
 * - the callback is called each time the component mounts (twice in strict mode)
 * - the return value of the callback (if provided) is called each time the component unmounts
 * - the callback does not re-run while its component remains mounted
 * - the onMount callback is run in a useLayoutEffect (before the browser repaints)
 */
export function useOnMountBeforePaint(onMount: EffectCallback) {
  const onMountRef = useRef(onMount);
  useLayoutEffect(() => onMountRef.current(), []);
}
